interface SearchResetButtonsProps {
  onSearch: () => void;
  onReset: () => void;
}

const SearchResetButtons: React.FC<SearchResetButtonsProps> = (props) => {
  return (
    <div className="page-menu__item">
      <div className="page-menu__label" />
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px' }}>
        <button className="pa-button black wxl" onClick={() => props.onSearch()}>
          검색
        </button>
        <button className="pa-button white wxl" onClick={() => props.onReset()}>
          초기화
        </button>
      </div>
    </div>
  );
};

export default SearchResetButtons;
